import React from "react";
import PaperRow from "./PaperRow";

export default function PhaseBlock({ phase, papers }) {
  return (
    <div>
      <p style={{ color: "#9d4edd", marginBottom: "1rem" }}>{phase.label}</p>

      <h2 style={{ marginBottom: "2rem" }}>{phase.title}</h2>

      {papers.map((paper, index) => (
        <PaperRow key={paper.day} paper={paper} id={index + 1} />
      ))}
    </div>
  );
}
